import { render, staticRenderFns } from "./ContactTypeFields.vue?vue&type=template&id=4e3bb312&scoped=true&"
import script from "./ContactTypeFields.vue?vue&type=script&lang=js&"
export * from "./ContactTypeFields.vue?vue&type=script&lang=js&"
import style0 from "./ContactTypeFields.vue?vue&type=style&index=0&id=4e3bb312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3bb312",
  null
  
)

export default component.exports